var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 512 356",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E03C31",
    fillRule: "nonzero",
    d: "M512 178.403H205.62L0 41.323V28.14C0 12.663 12.663 0 28.137 0H483.86C499.337 0 512 12.663 512 28.14v150.263z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#001489",
    fillRule: "nonzero",
    d: "M512 178.403H205.62L0 315.484v12.556c0 15.477 12.663 28.14 28.137 28.14H483.86c15.477 0 28.14-12.663 28.14-28.14V178.403z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M223.631 237.885L46.189 356.18H28.137C12.663 356.18 0 343.517 0 328.04V28.14C0 12.663 12.663 0 28.137 0h17.111l178.383 118.921H512v118.964H223.631z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M205.62 178.403L0 315.484"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB81C",
    d: "M.444 23.166l222.505 160.335L2.637 339.897A27.885 27.885 0 010 328.04v-84.045l98.388-65.592L0 112.812V28.14c0-1.697.153-3.358.444-4.974z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#007749",
    d: "M216.427 214.092L11.511 350.703C4.542 345.568 0 337.309 0 328.04v-55.45l141.281-94.187L0 84.216V28.14c0-9.072 4.351-17.176 11.069-22.33l205.358 136.905H512v71.377H216.427z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.388 178.403L0 112.812v131.182z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsa);
export default __webpack_public_path__ + "static/media/rsa.393d0169977fe83537d37b18feaa3990.svg";
export { ForwardRef as ReactComponent };